<header class="header-area border-bottom-radius box-shadow mb-0 pb-0 mat-app-background "
  [ngClass]="{ active: isToggled, sticky: isSticky }" [class.component-dark-theme]="themeService.isDark()"
  [class.right-sidebar]="themeService.isRightSidebar()" [class.hide-sidebar]="themeService.isHideSidebar()"
  [class.dark-header]="themeService.isHeaderDark()" [class.card-borderd-theme]="themeService.isCardBorder()"
  [class.card-border-radius]="themeService.isCardBorderRadius()" [class.rtl-enabled]="themeService.isRTLEnabled()"
  *ngIf="islogin">
  <div class="d-md-flex justify-content-space-between ps-0 ">
      <div style="width: 200px; margin-right: 0.5rem;">
        <a href="https://nectum-investment.com/" class="d-flex align-items-left" target="_blank">
          <img src="assets/img/logo_dark.png" alt="logo" *ngIf="isDark" class="custom-img" />
          <img src="assets/img/logo.png" alt="logo" class="custom-img" *ngIf="!isDark" /><!-- cambiar aqui la imagen -->
        </a>
      </div>
      <div class="header-center-group d-flex align-items-end">
      <ul class="menu-nuevo d-flex align-items-end mt-0 mb-0 ml-3 botonesMenu">

        <li routerLinkActive="active" [routerLinkActiveOptions]="rlaSubset">
          <a routerLink="/mercados" class="" target="_blank">
            <!-- <i class="flaticon-chart"></i> -->
            <span class="title">Mercados</span>
          </a>
        </li>
        
        <!--li routerLinkActive="active" [routerLinkActiveOptions]="rlaExact">
          <a routerLink="/stock" class="" target="_blank">
            
            <span class="title">Screener</span>
          </a>
        </li-->
        
        <li [class.active]="enPlanificador">
          <a routerLink="/models" class="" target="_blank">
           
            <span class="title">Planificador</span>
          </a>
        </li>
        <li routerLinkActive="active" [routerLinkActiveOptions]="rlaExact">
          <a routerLink="/strategyfactory" class="" target="_blank">

            <span class="title">Strategy Factory</span>
          </a>
        </li>
        <li routerLinkActive="active" [routerLinkActiveOptions]="rlaExact">
          <a routerLink="/portfolio-labs" class="" target="_blank">

            <span class="title">Portfolio Labs</span>
          </a>
        </li>
        <li [class.active]="enScreener">
          <a routerLink="/models" [queryParams]="{ modo: 'analisis' }" class="" target="_blank">
            <span class="title">Screener</span>
          </a>
        </li>

        <!--li routerLinkActive="active" [routerLinkActiveOptions]="rlaSubset">
          <a  (click)="checkActive('gestor')" routerLink="/gestor"  class="{{rutagestor}}">
            <span class="title">Gestor</span>
          </a>
        </li-->

        <li class="has-dropdown">
          <a class="dropdown-trigger">
            <span class="title">Servicios ▾</span>
          </a>
          <ul class="dropdown-menu">
            <li><a (click)="verSuscripciones()"><span>Automatización Carteras</span></a></li>
            <li><a (click)="gestionarlistas()"><span>Configurar Mercados/Activos</span></a></li>
            <li><a (click)="irASeguimientoCarteras()"><span>Ver actualizaciones de carteras</span></a></li>
          </ul>
        </li>

        <!--li routerLinkActive="active" [routerLinkActiveOptions]="rlaExact">
          <a [routerLink]="['/rastreador']" class="" target="_blank">

            <span class="title">Rastreador</span>
          </a>
        </li-->

        <li *ngIf="isAdmin" class="has-dropdown" routerLinkActive="active" [routerLinkActiveOptions]="rlaSubset">
          <a class="dropdown-trigger">
            <span class="title">Social ▾</span>
          </a>
          <ul class="dropdown-menu">
            <li><a routerLink="/social"><span>Publicaciones</span></a></li>
            <li><a routerLink="/newsletter"><span>Newsletter</span></a></li>
            <li><a routerLink="/social/comments"><span>Comentarios</span></a></li>
          </ul>
        </li>

        <li *ngIf="isAdmin" class="has-dropdown" routerLinkActive="active" [routerLinkActiveOptions]="rlaSubset">
          <a class="dropdown-trigger">
            <span class="title">Admin ▾</span>
          </a>
          <ul class="dropdown-menu">
            <li><a routerLink="/admin"><span>Datos</span></a></li>
            <li><a routerLink="/admin-usuarios"><span>Usuarios</span></a></li>
            <li><a routerLink="/admin-usuarios-chat"><span>Usuarios Chat</span></a></li>
            <li><a routerLink="/admin-metaapi-cuentas"><span>MetaAPI Cuentas</span></a></li>
          </ul>
        </li>

      </ul>
      <ul class="header-right-side d-flex align-items-end mt-0 mb-0 ml-3 botonesMenu">
        <li routerLinkActive="active" [routerLinkActiveOptions]="rlaExact"><!-- (click)="openDialog()"  -->
          <a  class="sidebar-menu-link me-2" style="cursor:pointer" (click)="checkActive('broker')">
            <div class="svg-container broker-logo-wrapper">
              <!-- Always show both broker logos, tag appears over the active one -->
              <div class="broker-logo-dual">
                <div class="broker-logo-item">
                  <span class="broker-status-tag" *ngIf="brokerConectado && brokerTipoBroker === 'IBKR'"
                    (click)="$event.stopPropagation(); botonSesionBroker()">
                    <span class="broker-status-tag__dot" [class.broker-status-tag__dot--checking]="brokerVerificando"></span>
                    {{ brokerVerificando ? 'Verificando...' : 'Conectado - ' + ultima_cuenta_broker }}
                  </span>
                  <img src="assets/logos/interactive-brokers-stacked.svg" class="svg-icon-small" *ngIf="!isDark" alt="IBKR">
                  <img src="assets/logos/interactive-brokers-stacked-inverse.svg" class="svg-icon-small" *ngIf="isDark" alt="IBKR">
                </div>
                <div class="broker-logo-item">
                  <span class="broker-status-row" *ngIf="brokerTipoBroker === 'METAAPI' && (brokerConectado || metaApiConCredenciales)">
                    <span class="broker-status-tag" *ngIf="brokerConectado"
                      (click)="$event.stopPropagation(); botonSesionBroker()">
                      <span class="broker-status-tag__dot" [class.broker-status-tag__dot--checking]="brokerVerificando"></span>
                      {{ brokerVerificando ? 'Verificando...' : (meta_api_account_login ? 'Conectado - ' + meta_api_account_login : 'Conectado') }}
                    </span>
                    <select class="broker-region-select" title="Región MetaAPI" *ngIf="!metaApiGateway"
                      [ngModel]="metaApiRegion" (ngModelChange)="cambiarRegionMetaApi($event)"
                      (click)="$event.stopPropagation()">
                      <option *ngFor="let r of metaApiRegiones" [value]="r">{{ r }}</option>
                    </select>
                  </span>
                  <img src="assets/logos/metatrader5.svg" class="svg-icon-small" alt="MT5" *ngIf="!isDark">
                  <img src="assets/logos/metatrader5-inverse.svg" class="svg-icon-small" alt="MT5" *ngIf="isDark">
                </div>
              </div>
            </div>
          </a>
        </li>


       </ul>
      </div>

    <ul class="header-right-side header-actions d-flex align-items-center mt-0 mb-0">

      <!-- Notificaciones -->
      <li>
        <button mat-icon-button [matMenuTriggerFor]="notificationMenu"
          [ngClass]="obtenerClaseIndicadorNotificaciones()">
          <i class="flaticon-bell-2"></i>
        </button>
        <mat-menu class="menu-dropdown" #notificationMenu="matMenu" xPosition="before">
          <div class="menu-header d-flex align-items-center justify-content-space-between">
            <h5 class="m-0">Notificaciones</h5>
          </div>
          <ul class="menu-body">
            <li *ngFor="let notificacion of listaNotificaciones" class="position-relative">
              <div class="d-flex">
                <i class="flaticon-file-1 icon"></i>
                <div class="title">
                  <h6>{{notificacion.titulo}}</h6>
                  <span><i class="flaticon-timer"></i>{{ notificacion.fecha | date }}</span>
                </div>
              </div>
              <a (click)="verDetalleNotificacion(notificacion)" class="link-btn" style="cursor: pointer;"></a>
              <button (click)="guardarNotificacion(notificacion)" class="close-btn bg-transparent border-none p-0">
                <i class="flaticon-close"></i>
              </button>
            </li>
          </ul>
          <div class="menu-footer">
            <a routerLink="/notifications" class="fw-medium position-relative">Ver todas <i class="flaticon-chevron"></i></a>
          </div>
        </mat-menu>
      </li>

      <!-- Dark mode toggle -->
      <li>
        <button class="header-theme-toggle"
          (click)="toggleTheme()"
          [title]="isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'">
          <span class="material-symbols-outlined">{{ isDark ? 'light_mode' : 'dark_mode' }}</span>
        </button>
      </li>

      <!-- Separador vertical -->
      <li class="header-vdivider" aria-hidden="true"></li>

      <!-- Perfil -->
      <li>
        <button mat-button [matMenuTriggerFor]="profileMenu" class="profile-btn-clean">
          <img src="assets/img/admin.jpg" class="profile-avatar" alt="admin" />
          <span class="notification-text" *ngIf="notificacion">{{ notificacion }}</span>
          <mat-icon class="profile-chevron">expand_more</mat-icon>
        </button>
        <mat-menu class="profile-menu-dropdown" #profileMenu="matMenu" xPosition="before">
          <!-- Info usuario -->
          <div class="profile-menu-user" (click)="$event.stopPropagation()">
            <img src="assets/img/admin.jpg" class="profile-menu-avatar" alt="admin" />
            <div class="profile-menu-info">
              <span class="profile-menu-email">{{ usernameglobal }}</span>
            </div>
          </div>
          <button mat-menu-item routerLink="/profile"
            [ngClass]="{'custom-menu': !isDark, 'custom-menu-dark': isDark}">
            <mat-icon>person</mat-icon>
            Perfil
          </button>
          <button mat-menu-item (click)="version()"
            [ngClass]="{'custom-menu': !isDark, 'custom-menu-dark': isDark}">
            <mat-icon>info</mat-icon>
            Version {{currentVersion}}
          </button>
          <button mat-menu-item routerLink="/logout" class="logout-item"
            [ngClass]="{'custom-menu': !isDark, 'custom-menu-dark': isDark}">
            <mat-icon>logout</mat-icon>
            Cerrar sesión
          </button>
        </mat-menu>
      </li>

    </ul>
  </div>
</header>